import {DiaryActionType, DiaryState} from "./types";

const initialState: DiaryState = {
    diary: null,
    loading: false,
    message: "",
};
const DiaryReducer = (state = initialState, action: any): DiaryState => {
    switch (action.type) {
        case DiaryActionType.START_REQUEST:
            return { ...state, loading: true };
        case DiaryActionType.DIARY_LOADED:
            return { ...state, loading: false, diary: action.payload };
        case DiaryActionType.FINISH_REQUEST:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default DiaryReducer;
